import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import {
  BASE_COLORS,
  ERROR_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'
import { isExpiredEvent } from 'lib/utils'
import moment from 'moment/moment'
import { Modal } from 'asterX-UI/Modals'
import TaskModal from 'components/Desktop/Tasks/TaskModal'
import { CS_ISSUE_MANAGER } from 'constants/events'

const useStyles = makeStyles(theme => ({
  rootCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 16,
    padding: 16,
    borderRadius: 12,
    marginTop: 12
  },
  card: {
    backgroundColor: BASE_COLORS.White
  },
  expiredCard: {
    backgroundColor: ERROR_COLORS[50],
    border: `1px solid ${ERROR_COLORS[350]}`
  },
  csIssueManager: {
    backgroundColor: PRIMARY_COLORS[50],
    border: `1px solid ${PRIMARY_COLORS[350]}`
  },
  headerBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    fontFamily: 'Inter',
    color: GRAY_COLORS[700]
  },
  time: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    fontFamily: 'Inter',

    '&.expired': {
      color: ERROR_COLORS[500]
    },
    '&.today': {
      color: WARNING_COLORS[500]
    },
    '&.tomorrow': {
      color: SUCCESS_COLORS[500]
    }
  },
  text: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    fontFamily: 'Inter'
  },
  redChip: {
    borderRadius: 12,
    color: ERROR_COLORS[600],
    border: `1.5px solid ${ERROR_COLORS[600]}`,
    fontSize: 12,
    padding: '2px 8px',
    lineHeight: '18px',
    fontFamily: 'Inter',
    fontWeight: 500
  }
}))

const TaskCard = ({ task, isClosedTasks, isRop = false, reload }) => {
  const classes = useStyles()
  const isExpired = isExpiredEvent(task)
  const endDateSplit = task.end.split(' ')
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false)

  const getTime = () => {
    const date = moment(endDateSplit, 'YYYY-MM-DD')
    const isThisYear = date.isSame(new Date(), 'year')
    const isToday = date.isSame(new Date(), 'day')
    const isTomorrow = date.isSame(moment(new Date()).add(1, 'day'), 'day')
    const isExpired = isExpiredEvent(task) && !isClosedTasks
    if (isToday) {
      return {
        label: 'Сегодня ' + endDateSplit[1],
        className: 'today'
      }
    }
    if (isTomorrow) {
      return {
        label: 'Завтра ' + endDateSplit[1],
        className: 'tomorrow'
      }
    }
    if (isThisYear) {
      return {
        label: date.format('Do MMM ') + endDateSplit[1],
        className: isExpired ? 'expired' : ''
      }
    }
    return {
      label: date.format('Do MMM YYYY ') + endDateSplit[1],
      className: isExpired ? 'expired' : ''
    }
  }

  const endDate = getTime()

  return (
    <>
      <div
        className={clsx(
          classes.rootCard,
          isExpired && !isClosedTasks
            ? classes.expiredCard
            : task.type === CS_ISSUE_MANAGER
            ? classes.csIssueManager
            : classes.card
        )}
        onClick={() => setIsTaskModalOpen(!isTaskModalOpen)}
      >
        <div className={classes.headerBox}>
          <div className={classes.header}>
            <div className={classes.title}>{task.title}</div>
            <div className={clsx(classes.time, endDate.className)}>
              {endDate.label}
            </div>
          </div>
          <div className={classes.text}>{`${task.contactFullname}`}</div>
        </div>
        <div className={classes.text}>
          {isClosedTasks ? task.result : task.description}
        </div>
        {isExpired && !isClosedTasks && (
          <div
            style={{
              display: 'flex'
            }}
          >
            <div className={classes.redChip}>{'Просрочено'}</div>
          </div>
        )}
      </div>
      <Modal open={isTaskModalOpen} fullWidth maxWidth={'md'}>
        <TaskModal
          onClose={() => {
            setIsTaskModalOpen(false)
            reload && reload()
          }}
          task={task}
          endDate={endDate}
        />
      </Modal>
    </>
  )
}
export default TaskCard
